<div class="tt-sidebar-resource-tags">
  <div class="tt-sidebar-resource-tags_header">
    <h5 class="tt-sidebar-resource-tags_header-title">{{ 'ResourceTag.Header' | transloco }}</h5>
    <button
      #triggerButton
      aria-label="Add a Resource Tag"
      ttButton
      [emphasis]="'minimal'"
      [size]="'icon'"
      [variant]="'primary'"
      (click)="openDropdown($event)">
      <mat-icon [icon]="'circle-plus-filled'" [iconSize]="18" />
    </button>
  </div>
  <tt-resource-tag-list [tags]="selectedTags()" (tagRemoved)="removeTag($event)" />
</div>

<ng-template #addResourceTagsTemplate>
  <tt-add-resource-tags [selectedTags]="selectedTags()" (tagsChanged)="handleTagsChanged($event)" />
</ng-template>
